import type React from "react";

import "./i18n";
import "./tailwind.css";

import { RouterProvider } from "@tanstack/react-router";

import { router } from "./router";

export const UI: React.FC = () => {
  return <RouterProvider router={router} />;
};
